/** The sources the weekly view breaks down by; every other source, unknown included, is "other". */
export type ReportSource = 'google_ads' | 'chatgpt' | 'youtube_ads' | 'other';

/**
 * The sources the reports break down by, each with a fixed colour, so a source keeps
 * the same colour on every report (dataviz: colour follows the entity, never its rank).
 * Categorical slots in fixed order; "Other" takes the de-emphasis grey.
 */
export const SOURCE_SERIES: { key: ReportSource; label: string; swatch: string; line: string }[] = [
  { key: 'google_ads', label: 'Google Ads', swatch: 'bg-cat-1', line: 'bg-cat-1' },
  { key: 'chatgpt', label: 'ChatGPT', swatch: 'bg-cat-2', line: 'bg-cat-2' },
  { key: 'youtube_ads', label: 'YouTube Ads', swatch: 'bg-cat-3', line: 'bg-cat-3' },
  { key: 'other', label: 'Other', swatch: 'bg-viz-muted', line: 'bg-viz-muted' },
];

/** The series a first-touch source counts under. */
export const seriesOf = (source: string): ReportSource =>
  SOURCE_SERIES.some((s) => s.key === source) ? (source as ReportSource) : 'other';

/** First-touch sources that are AI assistants, detected from the referrer (ATT-4). */
export const AI_SOURCES = new Set(['chatgpt', 'perplexity', 'claude', 'gemini', 'copilot']);

/** "46%", or a dash when there is nothing to divide by. */
export const percent = (part: number, whole: number) => (whole > 0 ? `${Math.round((part / whole) * 100)}%` : '—');
